<template>
  <div class="relative inline-block input-container">
    <button class="btn-left" :disabled="value === min" @click="decrement">
      -
    </button>
    <input
      type="number"
      :value="value"
      :min="min"
      :max="max"
      class="w-full inline-block"
      @input="emitValue(parseInt($event.target.value))"
    />
    <button class="btn-right" :disabled="value === max" @click="increment">
      +
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
  },
  methods: {
    emitValue(val) {
      this.$emit("input", parseInt(val))
    },
    decrement() {
      if (this.value > this.min) this.emitValue(this.value - 1)
    },
    increment() {
      if (this.value < this.max) this.emitValue(this.value + 1)
    },
  },
}
</script>

<style scoped lang="scss">
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.btn-left,
.btn-right {
  @apply bg-transparent text-grey-darkest;
  position: absolute;
  top: 50%;
  width: 2rem;
  height: 2rem;
  border-radius: 0;

  font-weight: normal;
  transform: translateY(-50%);
}

.btn-left {
  left: 0;
}

.btn-right {
  right: 0;
}

.input-container {
  width: 8rem;
}

.input-container input {
  height: 2rem;
  margin: 0 !important;
  padding: 0 2.5rem !important;
}
</style>
